import axios from "axios"
import FileSaver from "file-saver"

export const downloadFile = (absoluteUrl, locations, access_token, onStart, onSuccess, onFail) => {
  onStart()
  const data = { LocationIds: locations }

  axios
    .put(absoluteUrl, data, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    })
    .then((response) => {
      // Taken from https://stackoverflow.com/a/45895847/1024152
      onSuccess()
      const fileNameHeader = "x-suggested-filename"
      const suggestedFileName = response.headers[fileNameHeader]
      const effectiveFileName = suggestedFileName === undefined ? "export.xlsx" : suggestedFileName

      // Let the user save the file.
      FileSaver.saveAs(response.data, effectiveFileName)
    })
    .catch((response) => {
      if (onFail) {
        onFail()
        // console.error("Could not Download the Excel report from the backend.", response)
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/file-utils.js